import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FreightPayer } from './models/FreightPayer';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FreightPayersService {

  constructor(private http$: HttpClient) { }

  search(term: string = ""): Observable<FreightPayer[]> {
    if (term === "") return this.http$.get<FreightPayer[]>('/api/freightpayer');
    return this.http$.get<FreightPayer[]>(`/api/freightpayer?term=${term}`);
  }
}
